import type {TipData} from '@/types/experienceScore';

import ESTip from './ESTip';
import useTipClick from './hooks/useTipClick';

interface TipItemProps {
    tip: TipData;
    className?: string;
    onBeforeAction?: () => void;
}

const TipItem = ({tip, className, onBeforeAction}: TipItemProps) => {
    const runAction = useTipClick(tip);
    const {code, action, isButtonActive, ...rest} = tip;
    const onClick =
        runAction &&
        (() => {
            onBeforeAction?.();
            runAction();
        });

    return <ESTip className={className} onClick={onClick} {...rest} />;
};

export default TipItem;
